// Taking an intake-born matter into work. The server decides the
// winner atomically; a 409 here means someone else just did.

import { getAuthHeaders } from "./auth";

export class ClaimTakenError extends Error {}

export async function claimMatter(caseId: string): Promise<void> {
  const res = await fetch(`/api/cases/${encodeURIComponent(caseId)}/claim`, {
    method: "POST",
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (res.status === 409) throw new ClaimTakenError("Someone already took this matter");
  if (!res.ok) throw new Error(`POST /api/cases/:id/claim failed: ${res.status}`);
}
